import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayByShift } from "../../report/models/DelayByShift";
import { DelayForPareto } from "../models/DelayForPareto";

type getDelaysForParetoProps = {
	startDate: Date;
	endDate: Date;
	delayCodeId?: number | null;
	delayCategoryId?: number | null;
	shiftId?: number | null;
	crew?: string | null;
	delayAreaAssetId?: number | null;
	includeMicroDelays: boolean;
	includeUndeclared: boolean;
	includeRollChange: boolean;
};

export const getDelaysForPareto = async (
	params: getDelaysForParetoProps,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: params.startDate?.toISOString() ?? null },
		{ name: "End", value: params.endDate?.toISOString() ?? null },
		{
			name: "DelayAreaAssetId",
			value: params.delayAreaAssetId || null,
		},
		{
			name: "DelayCategoryId",
			value: params.delayCategoryId || null,
		},
		{
			name: "DelayCodeId",
			value: params.delayCodeId || null,
		},
		{
			name: "ShiftId",
			value: params.shiftId || null,
		},
		{
			name: "Crew",
			value: params.crew || null,
		},
		{
			name: "IncludeMicrodelays",
			value: params.includeMicroDelays,
		},
		{
			name: "IncludeUndeclared",
			value: params.includeUndeclared,
		},
		{
			name: "IncludeRollChange",
			value: params.includeRollChange,
		},
	];

	const resp = await apiService.callV2(
		"[DEL].[GetDelaysForPareto]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayForPareto[];
	} else {
		throw new Error(resp.message || "Error fetching delays for pareto");
	}
};

type getDelaysByCodeProps = {
	startDate: Date;
	endDate: Date;
	delayCodeId: number | null;
	delayAreaAssetId?: number | null;
	includeMicroDelays: boolean;
};

export const getDelaysByCode = async (
	params: getDelaysByCodeProps,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "StartDate", value: params.startDate?.toISOString() ?? null },
		{ name: "EndDate", value: params.endDate?.toISOString() ?? null },
		{ name: "DelayAreaAssetId", value: params.delayAreaAssetId || null },
		{ name: "IncludeMicrodelays", value: params.includeMicroDelays },
		{ name: "DelayCodeId", value: params.delayCodeId },
	];

	const resp = await apiService.callV2("[DEL].[GetDelays]", parameters, signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayByShift[];
	} else {
		throw new Error(resp.message || "Error fetching delay events");
	}
};
